import { computed } from 'vue'
import type { ButtonSize, ButtonSizeValue } from '../components/base/button/button-size'
import { useBreakpoint } from './use-break-points'

export const useButtonSize = (size: ButtonSize) => {
  const { breakpoints } = useBreakpoint()

  const actualSize = computed<ButtonSizeValue>(() => {
    if (typeof size === 'string') {
      return size
    }
    let actualSize: ButtonSizeValue = size.base
    for (const breakpoint of breakpoints.current().value) {
      if (size[breakpoint] && breakpoints.isGreaterOrEqual(breakpoint)) {
        actualSize = size[breakpoint]
      }
    }
    return actualSize
  })

  return {
    actualSize,
  }
}
